import { $ } from "@olmokit/dom";
import { breakpoints, gridGutter } from "@olmokit/core/scss";
import {
  glide,
  Anchors,
  Breakpoints,
  LazyLoad,
  Swipe,
} from "@olmokit/core/glide";
import "./products.scss";

export default function collectionProductsSlider() {
  const $container = $(".products:list .glide");
  const slider = glide(
    $container,
    {
      loop: false,
      killWhen: { above: breakpoints.xl },
      bound: true,
      breakpoints: {
        [breakpoints.xl]: {
          perView: 4,
          gap: gridGutter,
          peek: { before: 0, after: gridGutter * 3 },
        },
        [breakpoints.lg]: {
          perView: 3.5,
          gap: gridGutter / 2,
          peek: { before: 0, after: gridGutter * 2 },
        },
        [breakpoints.md]: {
          perView: 3,
          gap: gridGutter / 2,
          peek: { before: 0, after: gridGutter * 1.5 },
        },
        [breakpoints.sm]: {
          perView: 2,
          gap: gridGutter / 2,
          peek: { before: 0, after: gridGutter },
        },
        440: {
          perView: 1,
          gap: gridGutter / 2,
          peek: { before: 0, after: gridGutter },
        },
      },
    },
    { Swipe, Anchors, Breakpoints, LazyLoad }
  );

  return slider;
}
